export default __webpack_public_path__ + "static/media/11_4.e3d5c1e2.png";